import React, { useState } from 'react';

const TailArena = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Replace this URL with your deployed Tail Arena app URL
  const appUrl = 'https://straygames8.github.io/Tail-Arena/';

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-purple-900 to-black pt-24 pb-12 relative z-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-4">
            Tail Arena Demo
          </h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Interactive gaming arena with multiplayer features and real-time leaderboards
          </p>
        </div>

        {/* App Container */}
        <div className="relative bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl shadow-2xl overflow-hidden">
          {/* Loading State */}
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900/50 z-10">
              <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
                <p className="text-white text-lg">Loading app demo...</p>
              </div>
            </div>
          )}

          {/* Iframe Container */}
          <div className="relative w-full" style={{ paddingBottom: '75%' }}>
            <iframe
              src={appUrl}
              title="Tail Arena Demo"
              className="absolute top-0 left-0 w-full h-full"
              style={{
                minHeight: '600px',
                border: 'none',
              }}
              onLoad={handleIframeLoad}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
            />
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-white mb-2">Features</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Multiplayer gameplay</li>
              <li>• Real-time leaderboards</li>
              <li>• Achievement system</li>
              <li>• Social integration</li>
            </ul>
          </div>

          <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-white mb-2">Tech Stack</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• React Native</li>
              <li>• WebSocket/Real-time</li>
              <li>• Game engine</li>
              <li>• Cross-platform</li>
            </ul>
          </div>

          <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-white mb-2">Use Cases</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Competitive gaming</li>
              <li>• Community building</li>
              <li>• Tournaments</li>
              <li>• Skill development</li>
            </ul>
          </div>
        </div>

        {/* GitHub Link */}
        <div className="mt-8 text-center">
          <a
            href="https://github.com/Straygames8/Tail-Arena"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-lg transition-all duration-300 border border-white/20"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
            </svg>
            View Source Code on GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

export default TailArena;
